import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { startTokenKeepAlive } from '../services/tokenKeepAlive';

/**
 * Runs the proactive token keep-alive while the user is authenticated
 * (permanent-session-continuity design §4.6 Web). Never throws.
 */
export function useTokenKeepAlive() {
  const isAuthenticated = useSelector((state) => Boolean(state?.auth?.isAuthenticated));

  useEffect(() => {
    if (!isAuthenticated) return undefined;
    let stop = null;
    try {
      stop = startTokenKeepAlive();
    } catch (e) {
      console.warn('[useTokenKeepAlive] start failed:', e?.message || e);
    }
    return () => {
      try {
        if (typeof stop === 'function') stop();
      } catch (e) {
        console.warn('[useTokenKeepAlive] stop failed:', e?.message || e);
      }
    };
  }, [isAuthenticated]);
}

export default useTokenKeepAlive;
